import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_GRAPHQL_API_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set("x-api-key", process.env.REACT_APP_GRAPHQL_API_KEY!);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getApp: builder.query<any, { query: string; variables: any }>({
      query: (post) => {
        return {
          url: "",
          method: "POST",
          body: post,
        };
      },
      transformResponse: (response: any) => {
        return response.data;
      },
    }),
    setApp: builder.mutation<any, { query: string; variables: any }>({
      query: (post) => {
        return {
          url: "",
          method: "POST",
          body: post,
        };
      },
      transformResponse: (response: any) => {
        return response.data;
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAppQuery, useSetAppMutation, useLazyGetAppQuery } = appApi;

export const api = true;
